if (!customElements.get('google-reviews-carousel')) {
  const googleReviewAvatars = {
    'Mark C': 'https://lh3.googleusercontent.com/a/ACg8ocI3qF_VtgWHCzI-sEyGeoxMgjJhzMPbi0rUaQuWoZpSp55l9ylt=w160-h160-p-rp-mo-br100',
    'Liz Fong': 'https://lh3.googleusercontent.com/a-/ALV-UjXDM2O1k6EsjkIOHKUVqgm2JUNiWDKlTEyDp7uaDHvgsNUWmpzH=w160-h160-p-rp-mo-br100',
    'Minalli Vasandani': 'https://lh3.googleusercontent.com/a-/ALV-UjWPeKzoKHHLcYmzO8jqhIetix6T-wfv2zfCWZ1T5GO-kCXIL8pe_Q=w160-h160-p-rp-mo-br100',
    'Luke Yeh': 'https://lh3.googleusercontent.com/a/ACg8ocJ2PifR6yVj00GKeO7XiQ9ooFZf5zYOpimOOBEMroTFpummbQ=w160-h160-p-rp-mo-br100',
    'Jillian Newton': 'https://lh3.googleusercontent.com/a-/ALV-UjWZAimigoaJHEdKure1YPs2XAuEVBE_GrfEcULMwJUhzYF1nl-8zQ=w160-h160-p-rp-mo-br100',
    'Wayne Lawson': 'https://lh3.googleusercontent.com/a/ACg8ocK3xYpCpOlx4iidRSAeJZ3K3av7pPM6RKnj-RRhMS78rMGlzg=w160-h160-p-rp-mo-br100',
    'Carla Te Riini': 'https://lh3.googleusercontent.com/a/ACg8ocKw29z_iW6wxDFOjwW81032_k2mtK7NzAlVxryNL2LFwl3kQC0=w160-h160-p-rp-mo-br100',
    'Jackie Miller': 'https://lh3.googleusercontent.com/a/ACg8ocIPNLyYlrYMy1Q8WD_kVBU_M2CwcyXOaubXCAg7TlqQDMKncw=w160-h160-p-rp-mo-br100',
    'M S': 'https://lh3.googleusercontent.com/a/ACg8ocKBpXDyNBXxEn9c7x1uFXy3F9rWavJhIHu_TJUMjjGQ8OHy6w=w160-h160-p-rp-mo-br100',
    Watermelon: 'https://lh3.googleusercontent.com/a/ACg8ocKy5n9lf8Rt-h-mlMaNWNOKsUYtfBy54_29eheouGouLRdXzg=w160-h160-p-rp-mo-br100',
    'Alex | ADG': 'https://lh3.googleusercontent.com/a/ACg8ocILsgLozIHXB3ItKXD0sM1uLhFGSAYazsSS0UAc9DVVfEffQQ=w160-h160-p-rp-mo-br100',
    'ligang zhang': 'https://lh3.googleusercontent.com/a-/ALV-UjUww1iLYGuPqHSycXpCsMJ2iiCa4Fy-hKjUHkvO7V2KCnqSlH3f=w160-h160-p-rp-mo-br100',
    'Yu Hung': 'https://lh3.googleusercontent.com/a/ACg8ocK_vpdkvO9ElDfAUJ4bmvukzoIz2XRB2uelbiAIFk28nqZlhA=w160-h160-p-rp-mo-br100',
    Yan: 'https://lh3.googleusercontent.com/a-/ALV-UjVSwURhzuSt7b9Ued8poBk8hNI8IjJOmR7Gyvu6LXP1Rw9PAh8=w160-h160-p-rp-mo-br100',
    'Bill Donald': 'https://lh3.googleusercontent.com/a-/ALV-UjWqAwdGXFTmwQMxpBCRruF5_j1bx30nNL6YC3-z7BHVxyIZEmE=w160-h160-p-rp-mo-br100',
    'yu teng': 'https://lh3.googleusercontent.com/a/ACg8ocJt4K4cf299HtoGlTTtfBOXMv3Z_f6cwExSrmAcsUv-gRQg9Q=w160-h160-p-rp-mo-br100',
    'S Ahovelo': 'https://lh3.googleusercontent.com/a-/ALV-UjX1exk5P2QMIsr0zLROCAt-2qtXbBa-TF5yNiS6xXAVi8hjNRs=w160-h160-p-rp-mo-br100',
    Versitas: 'https://lh3.googleusercontent.com/a-/ALV-UjW5GtpbNIGkmg5OzzGCa4m8GWR8Lfptze4s7vTeBqWvGRupeRm3UQ=w160-h160-p-rp-mo-br100',
    'Matt Fraser': 'https://lh3.googleusercontent.com/a/ACg8ocJac8XE4eq-kQVmxUQJcpzKXNssCx4ELajqusrODY6RgiqOwg=w160-h160-p-rp-mo-br100',
    'Fiona Orchard': 'https://lh3.googleusercontent.com/a/ACg8ocIIHNun_Kz_dEwVs-yDRgQxXS5_83ydal319yRKx7GsrUUD7w=w160-h160-p-rp-mo-br100',
    'Anthea Jennings-Hingston': 'https://lh3.googleusercontent.com/a-/ALV-UjVvUp5SabHulfRZvs4uWNMneO2Oh9015ew_FstSs8YgcrR5LoI=w160-h160-p-rp-mo-br100',
    'Jam Aaliyahal': 'https://lh3.googleusercontent.com/a-/ALV-UjW1Dr3fPJQRzkB-HGI7Zf4QlANnUE8dQ2n8w3wEdWFA9WBLhv57YA=w160-h160-p-rp-mo-br100',
    'Barbel Grant': 'https://lh3.googleusercontent.com/a/ACg8ocIw5fWJIQ7LQckCMewEecK48_l09WTZ-RguECQ0SNtDEu2RxA=w160-h160-p-rp-mo-br100',
    'Laurel Y': 'https://lh3.googleusercontent.com/a/ACg8ocLv3VBObeUr4kRKu8PzKB2KpNJtEjWih58-KOpzddwtvC2vBQ=w160-h160-p-rp-mo-br100',
    'Warwick Ashley': 'https://lh3.googleusercontent.com/a/ACg8ocJ8b_YrlJNBpU1l8OPjT2eoG53323uskQ3uG-R0lc3GDcr7tA=w160-h160-p-rp-mo-br100',
    'Terry Stables': 'https://lh3.googleusercontent.com/a-/ALV-UjXVi1gAN8DiyQwCYmxDT5XEuL8rCR6CG3PRLo9JqriJjewKhVBn=w160-h160-p-rp-mo-br100',
    'greg parker': 'https://lh3.googleusercontent.com/a-/ALV-UjWMR1nO2F8mQLcXGU8-f3jaw8kU_bLg0gkTMZ1cew0anycqEIEv=w160-h160-p-rp-mo-br100',
    'Rene Ruegg': 'https://lh3.googleusercontent.com/a/ACg8ocJ-15dNWb2940Di_rYKz-3mLCI2EzkwpTnnjpzyp3gkayu4_Q=w160-h160-p-rp-mo-br100',
    'Peng Liu': 'https://lh3.googleusercontent.com/a/ACg8ocJXZAb9bDpokSPFm7iQEPfHBdn3FuDMt_igKa01Ei_5P4PK8Q=w160-h160-p-rp-mo-br100',
    'Ray Wang': 'https://lh3.googleusercontent.com/a-/ALV-UjWLGd6HWYHmpAuuDTjTjpxjxaqXM_UUf9BelTpNpyt_-UAe6DA=w160-h160-p-rp-mo-br100',
    'Stacy Chan': 'https://lh3.googleusercontent.com/a/ACg8ocLjSZ-8wqa5-MWMWBIte4yxD4VqcEEjDtSGHSKUjN5qPDvwuA=w160-h160-p-rp-mo-br100',
    'Q Yang': 'https://lh3.googleusercontent.com/a/ACg8ocKdUBjYFHdiIqwiSiv1UvkDWWrZuf664RzKGyVea-FfzLI1ow=w160-h160-p-rp-mo-br100',
    'Eve Olsen': 'https://lh3.googleusercontent.com/a-/ALV-UjXRg2I2MejnXK75LWtdyuhHVcf27wRIliSvUI-ZrKI3hoK-MOppIw=w160-h160-p-rp-mo-br100',
    'Amanda Habig': 'https://lh3.googleusercontent.com/a-/ALV-UjUQo-9dYvCWkvOOLh0ch-ChIzOtd9clqbIIKwaJBCoLTZXjVg_8=w160-h160-p-rp-mo-br100',
    'Rich in Sunny Queensland': 'https://lh3.googleusercontent.com/a-/ALV-UjV0iJvHnTx0W1aUuBxHEWTx5k40RGzrP4RuHdhSMX7rQmXlwTYw=w160-h160-p-rp-mo-br100',
    'olivia brankovic': 'https://lh3.googleusercontent.com/a/ACg8ocLz0xUi9FDvJydZAXDMGYHIDWrSc2BfbWP6cFdjYetd9SyRRg=w160-h160-p-rp-mo-br100',
    'Fiona Chan': 'https://lh3.googleusercontent.com/a/ACg8ocIttQIN5KqC_-nqvcektlka5fX4_Mnj5wlkXPgl73wN9rcYpQ=w160-h160-p-rp-mo-br100',
    'Scott Kerr': 'https://lh3.googleusercontent.com/a/ACg8ocKs7u1mDdOR9R9jrK1mQJ6voX3Snhu9y39b3Qwb0L6hGIQHXw=w160-h160-p-rp-mo-br100',
    'Francis Nagy': 'https://lh3.googleusercontent.com/a/ACg8ocIuSKuYH8HzOQADPfIBaMVhYMa0T3vhJDdFO9ZMtFNCd70c3g=w160-h160-p-rp-mo-br100',
    'backyard mechanic': 'https://lh3.googleusercontent.com/a-/ALV-UjVMRkYqrivE9nsMqaK3NEMMEyWlVG5kCxqAwe75PPfVQsGfodoe=w160-h160-p-rp-mo-br100',
    'Feilong Lin': 'https://lh3.googleusercontent.com/a-/ALV-UjXJnGeQ4RFYbPxHGs0o2erkPDij47IsGyQQYVjqjbqlqvfAkQuw=w160-h160-p-rp-mo-br100',
  };

  customElements.define(
    'google-reviews-carousel',
    class GoogleReviewsCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-carousel-viewport]');
        this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
        this.slides.sort((a, b) => (b.dataset.reviewDate || '').localeCompare(a.dataset.reviewDate || ''));
        this.slides.forEach((slide) => slide.parentElement.appendChild(slide));
        this.addGoogleAvatars();
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.status = this.querySelector('[data-carousel-status]');
        this.lightbox = this.querySelector('[data-review-lightbox]');
        this.lightboxImage = this.querySelector('[data-review-lightbox-image]');
        this.lightboxClose = this.querySelector('[data-review-lightbox-close]');
        this.lightboxPrevious = this.querySelector('[data-review-lightbox-previous]');
        this.lightboxNext = this.querySelector('[data-review-lightbox-next]');
        this.lightboxStatus = this.querySelector('[data-review-lightbox-status]');
        this.imageTriggers = [...this.querySelectorAll('[data-review-image-trigger]')];
        this.reviewToggles = [...this.querySelectorAll('[data-review-toggle]')];
        this.imageTriggers.forEach((button) => {
          button.addEventListener('click', () => this.openLightbox(button));
        });
        this.lightboxClose?.addEventListener('click', () => this.closeLightbox());
        this.lightboxPrevious?.addEventListener('click', () => this.moveLightbox(-1));
        this.lightboxNext?.addEventListener('click', () => this.moveLightbox(1));
        this.lightbox?.addEventListener('click', (event) => {
          if (event.target === this.lightbox) this.closeLightbox();
        });
        this.lightbox?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.moveLightbox(-1);
          if (event.key === 'ArrowRight') this.moveLightbox(1);
        });
        this.reviewToggles.forEach((button) => {
          button.addEventListener('click', () => this.toggleReview(button));
        });
        this.updateReviewToggles();
        if (!this.viewport || this.slides.length < 2) return;

        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
        window.addEventListener('resize', () => this.queueUpdate(), { passive: true });
        this.update();
      }

      addGoogleAvatars() {
        this.querySelectorAll('[data-review-card]').forEach((card) => {
          const name = card.dataset.reviewerName;
          const avatarUrl = googleReviewAvatars[name];
          if (!avatarUrl) return;
          const reviewer = card.querySelector('.google-reviews__reviewer');
          const currentImage = reviewer?.querySelector('.google-reviews__image');
          const initial = reviewer?.querySelector('.google-reviews__initial');
          if (currentImage) {
            currentImage.addEventListener('error', () => { currentImage.src = avatarUrl; }, { once: true });
            return;
          }
          if (!reviewer || !initial) return;
          const image = document.createElement('img');
          image.className = 'google-reviews__image';
          image.src = avatarUrl;
          image.alt = name;
          image.width = 80;
          image.height = 80;
          image.loading = 'lazy';
          image.addEventListener('error', () => image.replaceWith(initial), { once: true });
          initial.replaceWith(image);
        });
      }

      openLightbox(button) {
        if (!this.lightbox || !this.lightboxImage) return;
        this.lightboxItems = [...button.closest('.google-reviews__gallery').querySelectorAll('[data-review-image-trigger]')];
        this.lightboxIndex = this.lightboxItems.indexOf(button);
        this.renderLightbox();
        this.lightbox.showModal();
      }

      moveLightbox(direction) {
        if (!this.lightboxItems?.length) return;
        this.lightboxIndex = Math.max(0, Math.min(this.lightboxItems.length - 1, this.lightboxIndex + direction));
        this.renderLightbox();
      }

      renderLightbox() {
        const button = this.lightboxItems?.[this.lightboxIndex];
        if (!button || !this.lightboxImage) return;
        this.lightboxImage.src = button.dataset.reviewImageUrl || '';
        this.lightboxImage.alt = button.dataset.reviewImageAlt || '';
        if (this.lightboxPrevious) this.lightboxPrevious.disabled = this.lightboxIndex === 0;
        if (this.lightboxNext) this.lightboxNext.disabled = this.lightboxIndex === this.lightboxItems.length - 1;
        if (this.lightboxStatus) this.lightboxStatus.textContent = `Photo ${this.lightboxIndex + 1} of ${this.lightboxItems.length}`;
      }

      closeLightbox() {
        if (!this.lightbox?.open) return;
        this.lightbox.close();
        this.lightboxImage.removeAttribute('src');
        this.lightboxItems = [];
        this.lightboxIndex = 0;
      }

      toggleReview(button) {
        const card = button.closest('[data-review-card]');
        if (!card) return;
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        if (expanded) {
          card.setAttribute('data-expanded', 'true');
        } else {
          card.removeAttribute('data-expanded');
        }
        const moreLabel = button.querySelector('[data-review-more-label]');
        const lessLabel = button.querySelector('[data-review-less-label]');
        if (moreLabel) moreLabel.hidden = expanded;
        if (lessLabel) lessLabel.hidden = !expanded;
        if (!expanded) this.updateReviewToggle(button);
      }

      updateReviewToggle(button) {
        const card = button.closest('[data-review-card]');
        if (!card || button.getAttribute('aria-expanded') === 'true') return;
        card.setAttribute('data-review-collapsible', '');
        const content = card.querySelector('[data-review-content]');
        const gallery = card.querySelector('.google-reviews__gallery');
        const textIsClipped = Boolean(content && content.scrollHeight > content.clientHeight + 2);
        const photosAreClipped = gallery && gallery.querySelectorAll('.google-reviews__gallery-image').length > 3;
        const needsToggle = Boolean(textIsClipped || photosAreClipped);
        button.hidden = !needsToggle;
        if (!needsToggle) card.removeAttribute('data-review-collapsible');
      }

      updateReviewToggles() {
        this.reviewToggles.forEach((button) => this.updateReviewToggle(button));
      }

      queueUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }

      get index() {
        const left = this.viewport.scrollLeft;
        return this.slides.reduce((closest, slide, index) =>
          Math.abs(slide.offsetLeft - left) < Math.abs(this.slides[closest].offsetLeft - left) ? index : closest, 0);
      }

      move(direction) {
        const target = Math.max(0, Math.min(this.slides.length - 1, this.index + direction));
        this.viewport.scrollTo({ left: this.slides[target].offsetLeft, behavior: 'smooth' });
      }

      update() {
        const index = this.index;
        const atStart = this.viewport.scrollLeft <= 1;
        const atEnd = this.viewport.scrollLeft + this.viewport.clientWidth >= this.viewport.scrollWidth - 1;
        if (this.status) this.status.textContent = `Review ${index + 1} of ${this.slides.length}`;
        if (this.previousButton) this.previousButton.disabled = atStart;
        if (this.nextButton) this.nextButton.disabled = atEnd;
      }
    }
  );
}
